import { LinearProgress } from '@mui/material';
import React from 'react';
import { useStyles } from 'tss-react/mui';
import './linearProgressDelayed.scss';

export type LinearProgressDelayedProps = {
	loading: boolean;
	className?: string;
};

export const LinearProgressDelayed: React.FC<LinearProgressDelayedProps> = ({ loading, className }) => {
	const { cx } = useStyles();
	return <LinearProgress aria-label='progress' className={cx('linear-progress-delayed', loading && 'visible', className)} />;
};
